import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/game",
  redirect: "/game",
  name: "Game",
  component: LAYOUT,
  meta: {
    order: 30,
    roles: ManagerType.OrganizationReviewer,
  },
  children: [
    {
      path: "",
      name: "GamePage",
      component: () => import("@/views/game/GamePage.vue"),
      meta: {
        title: "赛事管理",
        roles: ManagerType.OrganizationReviewer,
        icon: "mdi:swim",
        keepAlive: true,
      },
    },
    {
      path: ":id",
      name: "GameDetailPage",
      component: () => import("@/views/game/GameDetailPage.vue"),
      meta: {
        title: "赛事详情",
        roles: ManagerType.OrganizationReviewer,
        hideMenu: true,
        keepAlive: true,
      },
    },
  ],
} as RouteRecordRaw;
